export const data: any = {
  NEXT_PUBLIC_SITE_MACHINE_NAME: "trimble-developer",
  NEXT_PUBLIC_CF_MXP_SPACE_ID: "rerp0bq2ntu3",
  BYPASS_CONSENT_CHECK: true
} 
